import React from "react";
import Select from "react-select/lib/Select";
import { MAIN_ROW_FILTER_TYPES } from "./data";

export default function SelectFilterOnComponent({ item, onDataChange, index,options }) {
  const handleOnChange = val => {
    onDataChange(index, val.value, "filterOn");
  };
  return (
    <div style={{ width: "150px" }}>
      <Select
        options={options}
        value={item.filterOn}
        onChange={handleOnChange}
      />
    </div>
  );
}
